export default __webpack_public_path__ + "static/mini-7-e763ee7f0bb4bdca69fb94a5f848c6ca.png";